/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function listToTree (data, id, parentId, children, rootId) {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || Math.min.apply(Math, data.map(item => {
    return item[parentId]
  })) || 0
  // 对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  // 循环所有项
  const treeData = cloneData.filter(father => {
    father[id] = father[id].toString()
    father[parentId] = father[parentId].toString()
    const branchArr = cloneData.filter(child => {
      child[parentId] = child[parentId].toString()
      // 返回每一项的子级数组
      return father[id] === child[parentId]
    })
    if (branchArr.length > 0) {
      father.children = branchArr
    }
    // 返回第一层
    return father[parentId] === rootId.toString()
  })
  return treeData !== '' ? treeData : data
}

/**
 * 递归查找树形数据
 * @param {Array} arr 数据集
 * @param {Number} id 查询ID
 */
export function getTreeItem (arr, id) {
  for (const item of arr) {
    if (item.id === id) return item
    if (item.children && item.children.length) {
      const _item = getTreeItem(item.children, id)
      if (_item) return _item
    }
  }
}

// 生成 min 到 max 的随机数
export function getRandomInt (min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

// 创建文件
export function createFile ({ filename, data }) {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    // IE 浏览器
    window.navigator.msSaveOrOpenBlob(data, filename)
  } else {
    // 火狐谷歌浏览器
    const url = URL.createObjectURL(data)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
    // 释放资源，以避免内存泄漏
    URL.revokeObjectURL(url)
  }
}

export function  findRouteCode(tree, code) {
  // 遍历树中的每个节点
  for (let i = 0; i < tree.length; i++) {
    const currentNode = tree[i];

    // 如果当前节点的code与要查找的code匹配，则返回当前节点
    if (currentNode.code === code) {
      return currentNode;
    }

    // 如果当前节点有子节点，则递归地在子节点中查找
    if (currentNode.children && currentNode.children.length > 0) {
      const foundNode = findRouteCode(currentNode.children, code);
      // 如果在子节点中找到了匹配的节点，则返回该节点
      if (foundNode) {
        return foundNode;
      }
    }
  }

  // 如果没有找到匹配的节点，则返回null
  return null;
}